export default "__VITE_ASSET__BR1cqbV5__"